var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalSlotted',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-kim",attrs:{"slot":"body"},slot:"body"},[_c('div',[_vm._t("body")],2),_c('Kim',{style:(_vm.position === 'left' ? 'order: -1' : ''),attrs:{"mood":_vm.mood,"color":_vm.color}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }